import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class PersonaService {
  private getAuthHeaders() {
    const token = localStorage.getItem('token');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  }

  /**
   * Upload persona icon (super admin only)
   * @param personaId - The ID of the persona
   * @param file - The image file to upload
   * @returns The icon URL
   */
  async uploadPersonaIcon(personaId: number, file: File): Promise<{ iconUrl: string }> {
    try {
      const formData = new FormData();
      formData.append('icon', file);

      console.log('Uploading persona icon:', { 
        personaId, 
        fileName: file.name, 
        size: file.size,
        type: file.type
      });

      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_BASE_URL}/personas/${personaId}/upload-icon`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      
      console.log('Upload response:', response.data);
      
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to upload icon');
      }
    } catch (error: any) {
      console.error('Error uploading persona icon:', error);
      throw new Error(error.response?.data?.message || error.message || 'Failed to upload icon');
    }
  }
}

export default new PersonaService();

